import userService from "../../../services/user.service";

async function getTaskPriorities({
  pageNumber = -1,
  pageSize = 0,
  searchQuery = "",
}) {
  try {
    const response = await userService.getTaskPriorities(
      pageNumber,
      pageSize,
      searchQuery
    );
    if (response.data && response.data.status) {
      console.log(response.data.result);
      return JSON.stringify(response.data.result);
    } else {
      return (
        JSON.stringify(response.data.message) ||
        "Failed to fetch task priorities."
      );
    }
  } catch (error) {
    const errorMessage =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      "An unexpected error occurred.";
    console.error("Error fetching task priorities:", errorMessage);
    return JSON.stringify(errorMessage);
  }
}

async function addTaskPriorityToDatabase({
  priorityName,
  priorityDescription,
  color,
  isActive,
}) {
  try {
    const payload = {
      name: priorityName,
      description: priorityDescription,
      color,
      active: isActive,
    };
    const response = await userService.addTaskPriority(payload);
    if (response.data && response.data.status) {
      console.log(response.data.result);
      return JSON.stringify(response.data.result);
    } else {
      return (
        JSON.stringify(response.data.message) || "Failed to add task priority."
      );
    }
  } catch (error) {
    const errorMessage =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      "An unexpected error occurred.";
    console.error("Error adding task priority:", errorMessage);
    return JSON.stringify(errorMessage);
  }
}

async function updateTaskPriorityInDatabase({
  priorityId,
  priorityName,
  priorityDescription,
  color,
  isActive,
}) {
  try {
    const payload = {
      id: priorityId,
      name: priorityName,
      description: priorityDescription,
      color,
      active: isActive,
    };
    const response = await userService.updateTaskPriority(payload);
    if (response.data && response.data.status) {
      console.log(response.data.result);
      return JSON.stringify(response.data.result);
    } else {
      return (
        JSON.stringify(response.data.message) ||
        "Failed to update task priority."
      );
    }
  } catch (error) {
    const errorMessage =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      "An unexpected error occurred.";
    console.error("Error updating task priority:", errorMessage);
    return JSON.stringify(errorMessage);
  }
}

export default {
  addTaskPriorityToDatabase,
  getTaskPriorities,
  updateTaskPriorityInDatabase,
  taskPriorityTools: [
    {
      type: "function",
      function: {
        name: "getTaskPriorities",
        description: "Fetch all task priorities from the database.",
        parameters: {
          type: "object",
          properties: {
            pageNumber: {
              type: "integer",
              description:
                "Page number for pagination by default it is -1 for fetching all tasks priorities",
            },
            pageSize: {
              type: "integer",
              description:
                "Number of items per page  by default it is 0 for fetching all task priorities",
            },
            searchQuery: {
              type: "string",
              description:
                "Search keyword for filtering task priorities by default it is empty string for fetching all task priorities",
            },
          },
          required: [],
        },
      },
    },
    {
      type: "function",
      function: {
        name: "updateTaskPriorityInDatabase",
        description: "Update an existing task priority in the database",
        parameters: {
          type: "object",
          properties: {
            priorityId: {
              type: "string",
              description: "The unique ID of the task priority to be updated",
            },
            priorityName: {
              type: "string",
              description: "Name of the task priority",
            },
            priorityDescription: {
              type: "string",
              description: "Description of the task priority",
            },
            color: {
              type: "string",
              description:
                "color of the task priority in hex number e.g. #00000",
            },
            isActive: {
              type: "boolean",
              description: "Whether the task priority is active or not",
            },
          },
          required: ["priorityId", "priorityName", "priorityDescription"],
        },
      },
    },
    {
      type: "function",
      function: {
        name: "addTaskPriorityToDatabase",
        description: "Add a new task priority to the database",
        parameters: {
          type: "object",
          properties: {
            priorityName: {
              type: "string",
              description: "Name of the task priority",
            },
            priorityDescription: {
              type: "string",
              description: "Description of the task priority",
            },
            color: {
              type: "string",
              description:
                "color of the task priority in hex number e.g. #00000",
            }
            ,
            isActive: {
              type: "boolean",
              description: "Whether the task priority is active or not",
            },
          },
          required: ["priorityName", "priorityDescription"],
        },
      },
    },
  ],
};
